import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { keys } from "../api/query-registry";

// ICP deadline forecast (Stage F) — homes x fortnights over the next N weeks.
// Counts are CURRENT next-deadlines only; future 1m->6m->1y cycles are not simulated.

export interface ForecastResident {
  id: string;
  name: string;
  bed: string | null;
  deadline: string;
  overdue: boolean;
}
export interface ForecastCell { date: string; residents: ForecastResident[] }
export interface ForecastRow { homeId: string; homeName: string; overdue: ForecastResident[]; cells: ForecastCell[] }
export interface Forecast { start: string; weeks: number; end: string; rows: ForecastRow[] }

export function useForecast(weeks: string) {
  return useQuery({
    queryKey: keys.forecast(weeks),
    queryFn: () => api<Forecast>(`/api/reminders/forecast?weeks=${weeks}`),
    staleTime: 30_000,
  });
}
